import { gql } from 'graphql-request'

export const GET_DYNAMIC_LINK = gql`
  query Query($link: String!) {
    dynamicLinkValidation(link: $link) {
      link
    }
  }
`
